




















































import { Vue, Component, Watch } from "vue-property-decorator";
import CategoryTable from "@/components/settings/CategoryTable.vue";
import eventCategoryService from "@/services/eventCategoryService";
import { getModule } from "vuex-module-decorators";
import SnackbarModule from "@/store/snackbarModule";
import UserModule from "@/store/userModule";
import CalendarModule from "@/store/calendarModule";
import ValidationService from "@/services/validationService";
import { DataTableHeader } from "vuetify";
import EventCategoryModel from "../../models/event/eventCategoryModel";

const snackbarModule = getModule(SnackbarModule);
const userModule = getModule(UserModule);
const calendarModule = getModule(CalendarModule);

@Component({ components: { CategoryTable } })
export default class Categories extends Vue {
  private items: Array<EventCategoryModel> = [];
  private dialogEdit: EventCategoryModel = new EventCategoryModel();
  private validationService: ValidationService = new ValidationService();
  private dialog = false;
  private dialogLoading = false;
  private loading = false;
  private dialogCreateMode = false;
  private headers: Array<DataTableHeader<EventCategoryModel>> = [
    {
      text: "Name",
      value: "name"
    },
    {
      text: "Colour",
      value: "colour"
    },
    {
      text: "",
      value: "action",
      sortable: false
    }
  ];
  private adminHeaders: Array<DataTableHeader<EventCategoryModel>> = [
    {
      text: "Name",
      value: "name"
    },
    {
      text: "Colour",
      value: "colour"
    },
    {
      text: "",
      value: "action",
      sortable: false
    },
    {
      text: "",
      value: "delete",
      sortable: false
    }
  ];

  get calendarId(): string {
    return calendarModule.getCalendarId;
  }

  private async created(): Promise<void> {
    await this.getCategories();
  }

  get userRole(): string {
    return userModule.userRole;
  }

  private async getCategories() {
    try {
      this.loading = true;
      this.items = await eventCategoryService.getAllEventCategorysByCalendarAsync(
        calendarModule.getCalendarId
      );
    } catch {
      snackbarModule.snackError("Failed to fetch categories");
    } finally {
      this.loading = false;
    }
  }

  private async onDeleteItem(item: EventCategoryModel) {
    if (
      confirm(
        "Deleting this category will also delete any events of this category type, Are you sure you want to delete this Category?"
      )
    ) {
      try {
        await eventCategoryService.deleteEventCategory(item.eventCategoryId);
        snackbarModule.snackSuccess("Category deleted");
      } catch {
        snackbarModule.snackError("Category delete failed");
      }
      await this.getCategories();
    }
  }

  private async onBeginEditItem(item: EventCategoryModel) {
    this.dialogCreateMode = false;
    this.dialog = true;
    this.dialogEdit = new EventCategoryModel(item);
  }

  private async onBeginCreateItem() {
    this.dialogCreateMode = true;
    this.dialog = true;
    this.dialogEdit = new EventCategoryModel();
  }

  private async onCancel() {
    (this.$refs.form as Vue & { reset: () => void }).reset();
    this.dialog = false;
    this.dialogEdit = new EventCategoryModel();
  }

  private async onEditItem() {
    if (!this.validateForm()) {
      return;
    }

    try {
      this.dialogLoading = true;
      await eventCategoryService.updateEventCategory(
        this.dialogEdit.eventCategoryId,
        this.dialogEdit
      );
      snackbarModule.snackSuccess("Category updated");
      this.dialog = false;
    } catch {
      snackbarModule.snackError("Category update failed");
    } finally {
      this.dialogLoading = false;
    }
    await this.getCategories();
  }

  private async onCreateItem() {
    if (!this.validateForm()) {
      return;
    }

    try {
      this.dialogLoading = true;
      this.dialogEdit.calendarId = calendarModule.getCalendarId;
      await eventCategoryService.createEventCategory(this.dialogEdit);
      snackbarModule.snackSuccess("Category Created");
      this.dialog = false;
    } catch {
      snackbarModule.snackError("Failed to create category");
    } finally {
      this.dialogLoading = false;
    }
    await this.getCategories();
  }

  private validateForm(): boolean {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate();
  }

  @Watch("calendarId")
  private async onCalendarChanged() {
    await this.getCategories();
  }
}
